import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--inner-shape-color, transparent)",
  fillRule: "evenodd",
  d: "M8 9.148a.7.7 0 0 1-.7-.7v-1.89a.7.7 0 1 1 1.4 0v1.89a.7.7 0 0 1-.7.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--inner-shape-color, transparent)",
  d: "M7.254 10.754a.746.746 0 1 1 1.492 0 .746.746 0 0 1-1.492 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.899 3.671c-.844-1.462-2.954-1.462-3.798 0l-3.819 6.616c-.805 1.395.202 3.139 1.813 3.139h7.81c1.611 0 2.618-1.744 1.813-3.14zM7.3 8.448a.7.7 0 1 0 1.4 0v-1.89a.7.7 0 1 0-1.4 0zm.7 1.56A.746.746 0 1 0 8 11.5a.746.746 0 0 0 0-1.492",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=WarningFilledIcon16.js.map